import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';

import { Observable } from 'rxjs';

import { ConfirmationService } from '@openng/optimus-ui/api';

import { EcuCoverageComponent } from 'src/app/components/ecu-coverage/ecu-coverage.component';

/**
 * Warns the user before an in-app (router) navigation away from the ECU Coverage
 * while editing is in progress. The `beforeunload` handler on
 * {@link EcuCoverageComponent} only covers tab close/reload, since the
 * Angular router never fires that event for its own navigations.
 * @param component
 */
export const ecuCoverageUnsavedChangesGuard: CanDeactivateFn<EcuCoverageComponent> = component => {
	if (!component.ecuCoverageService.hasEnteredData()) {
		return true;
	}

	const confirmationService = inject(ConfirmationService);

	return new Observable<boolean>(subscriber => {
		confirmationService.confirm({
			message: 'Do you want to leave this page? Any unsaved data will be lost.',
			header: 'Confirm navigation',
			icon: 'pi pi-exclamation-triangle',
			acceptButtonStyleClass: 'p-button-danger',
			rejectButtonStyleClass: 'p-button-secondary p-button-outlined',
			acceptIcon: 'none',
			rejectIcon: 'none',
			accept: () => {
				subscriber.next(true);
				subscriber.complete();
			},
			reject: () => {
				subscriber.next(false);
				subscriber.complete();
			},
		});
	});
};
